import React from 'react';
import * as styles from './Location.module.scss';
import useLocation from '../../hooks/useLocation';
import { LocationIcon } from '../V2/icons';

const Location = () => {
  const { country, city, isLoading } = useLocation();

  const countryName =
    country === 'United States of America (the)' ? 'USA' : country;

  return (
    <div className={styles.v2Location}>
      <LocationIcon />
      <p>{isLoading ? 'loading...' : `${city}, ${countryName}`}</p>
    </div>
  );
};

export default Location;
